module.exports = "/wp-content/plugins/farmacy/assets/js/images/glyphicons-halflings-regular-89889688147bd7575d6327160d64e760.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/scss/fonts/bootstrap/glyphicons-halflings-regular.svg
 ** module id = 230
 ** module chunks = 1 2 6 7 12 23 42 48 62
 **/